/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-betting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.47
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserGroupDefaultHighscoreRound
 */
export interface UserGroupDefaultHighscoreRound {
    /**
     * 
     * @type {string}
     * @memberof UserGroupDefaultHighscoreRound
     */
    tournamentRoundId?: string;
}

/**
 * Check if a given object implements the UserGroupDefaultHighscoreRound interface.
 */
export function instanceOfUserGroupDefaultHighscoreRound(value: object): value is UserGroupDefaultHighscoreRound {
    return true;
}

export function UserGroupDefaultHighscoreRoundFromJSON(json: any): UserGroupDefaultHighscoreRound {
    return UserGroupDefaultHighscoreRoundFromJSONTyped(json, false);
}

export function UserGroupDefaultHighscoreRoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupDefaultHighscoreRound {
    if (json == null) {
        return json;
    }
    return {
        
        'tournamentRoundId': json['tournamentRoundId'] == null ? undefined : json['tournamentRoundId'],
    };
}

export function UserGroupDefaultHighscoreRoundToJSON(value?: UserGroupDefaultHighscoreRound | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'tournamentRoundId': value['tournamentRoundId'],
    };
}

